import { Formatter } from '@repo/alt/common/Utils/Formatter'

export enum Formats {
  DATE_FORMAT = 'dd.MM.yyyy',
  DATE_FORMAT_LONG = 'dd MMMM yyyy',
  DATE_WITH_TIME_FORMAT = 'dd.MM.yyyy HH:mm',
  TIME_FORMAT = 'HH:mm',
  PHONE_FORMAT = '+# ### ###-##-##',
  BACKEND_FORMAT = 'yyyy-MM-dd',
}

export const useFormatter = () => {
  const { $dateFns } = useNuxtApp()

  function formatDate(date: Date | string, formatString = Formats.DATE_FORMAT) {
    if (typeof date === 'string') {
      date = $dateFns.parseISO(date)
    }

    if (!$dateFns.isValid(date)) {
      console.warn(`In not valid date: ${date}`)
      return date
    }
    return $dateFns.format(date, formatString)
  }

  function parseDateString(date: string, formatString = Formats.BACKEND_FORMAT) {
    const parsed = $dateFns.parse(date, formatString, new Date())
    return $dateFns.isValid(parsed) ? parsed : null
  }

  function formatDistance(date: Date | string, baseDate: Date | string) {
    if (typeof date === 'string') {
      date = $dateFns.parseISO(date)
    }
    if (typeof baseDate === 'string') {
      baseDate = $dateFns.parseISO(baseDate)
    }
    if (!$dateFns.isValid(date) || !$dateFns.isValid(baseDate)) {
      console.warn(`In not valid date: ${date} or ${baseDate}`)
      return ''
    }
    return $dateFns.formatDistance(date, baseDate)
  }

  return {
    $f: Formatter,
    formatDate,
    parseDateString,
    formatDistance,
  }
}
